import {ENDPOINT_URL} from '../constants';
import getFetchOptions from '../utils/getFetchOptions';

export default function updateRequiredTestUserInfo(payload) {
	return fetch(
		`${ENDPOINT_URL}/test-user/required-info`,
		getFetchOptions({
	method: 'PATCH',
	body: JSON.stringify(payload)
})
	).then((response) => {
		if (!response.ok) {
			throw new Error('Could not update required test user info');
		}

		return response.json();
	});
}